import React from 'react';
import PropTypes from 'prop-types';
import {
  DesktopAndTablet,
  Mobile,
} from 'Responsive';


const NavbarHeader = props => (
  <div
    className="rank-brain-2-sticky-navbar-header"
  >
    <select
      className="head-term-state-dropdown rank-brain-2-state-dropdown form-control"
    >
      {
        props.dropDownSelection.map(dropDownOption => (
          <option key={dropDownOption.name}>{dropDownOption.name}</option>
        ))
      }
    </select>

    <DesktopAndTablet>
      <a
        className={'btn btn-success btn-lg head-term-state-dropdown-button rank-brain-2-state-dropdown-button with-padding'}
        href={`/builder.php?documentType=${props.slug}`}
      >
        Create My Document
      </a>
    </DesktopAndTablet>
    <Mobile>
      <a
        className={'btn btn-success btn-lg head-term-state-dropdown-button rank-brain-2-state-dropdown-button with-padding'}
        href={`/builder.php?documentType=${props.slug}`}
      >
        Create
      </a>
    </Mobile>
  </div>
);


NavbarHeader.propTypes = {
  documentName: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  dropDownSelection: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })).isRequired,
};

export default NavbarHeader;



// WEBPACK FOOTER //
// ./src-react/RankBrain2StickyNavbar/NavbarHeader.jsx